/**
 * Apis Logger Detail Formatter.
 *
 * Pretty-prints the request headers and body (JSON when possible) in a
 * read-only code block.
 */
window.apisLoggerDetailFormatter = function(value, row) {
    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }

    function pretty(str) {
        if (!str) {
            return "";
        }
        try {
            return JSON.stringify(JSON.parse(str), null, 4);
        } catch (e) {
            return str;
        }
    }

    function block(label, str) {
        if (!str) {
            return "";
        }
        let html = "";
        html += '<div class="mb-3">';
        html += "<label class=\"fw-bold mb-1\">" + label + "</label>";
        html += '<pre class="border rounded bg-light p-2 mb-0" style="max-height: 320px; overflow: auto;"><code>' + escapeHtml(pretty(str)) + "</code></pre>";
        html += "</div>";
        return html;
    }

    return block(__("Request-Headers:"), row.headers) + block(__("Request-Content:"), row.content);
};
